// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__4IZR4","content":"Privacy_content__dDydj","title":"Privacy_title__FfkUw","update":"Privacy_update__o97Ml"};